import { useEffect } from 'react';
export function useScroll(onScroll) {
    useEffect(() => {
        onScroll();
        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', onScroll);
        window.addEventListener('orientationchange', onScroll);
        return function cleanup() {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
            window.removeEventListener('orientationchange', onScroll);
        };
    });
}
